import { BidStatuses, JobStatus } from 'Douleutaras/types';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { jobSelectors } from 'Douleutaras/redux/data/jobs/jobsSlice';
import { jobBidsSelectors } from 'Douleutaras/redux/data/jobBids/jobBidsSlice';
import { conversationSelectors } from 'Douleutaras/redux/data/conversations/conversationsSlice';

export const useReviewSupport = (jobId, bidId, sellerId) => {
  const job = useAppSelector(state => jobSelectors.selectById(state, parseInt(jobId, 0)));
  const bid = useAppSelector(state => jobBidsSelectors.selectById(state, bidId));

  const feedbackId = bid?.relationships.feedback?.data?.id;
  const jobStatus = job?.attributes.status;
  const hiredSellerId = job?.relationships.hiredSeller?.data?.id;
  const conversationId = bid?.relationships.conversation?.data?.id;

  const conversation = useAppSelector(state => conversationSelectors.selectById(state, conversationId));

  // Separate booleans for when user can review and already reviewed pro
  const reviewPosted: boolean = (Boolean(feedbackId) && jobStatus === JobStatus.CONCLUDED) && sellerId === hiredSellerId;
  const reviewAllowed: boolean = (!Boolean(feedbackId) && jobStatus === JobStatus.CONCLUDED)
    && sellerId === hiredSellerId
    && bid?.attributes?.canFeedback;

  // Check if a user is eligible to use CCF flow
  const disableCCFPositive: boolean = (
    (bid?.attributes?.status === BidStatuses.REJECTED && jobStatus === JobStatus.CONCLUDED)
    || jobStatus === JobStatus.CANCELLED
  );

  const isChatEmpty = typeof conversation === 'undefined' ? true : conversation?.attributes?.isEmpty;

  return {
    reviewPosted,
    reviewAllowed,
    disableCCFPositive,
    isChatEmpty,
    conversationId
  };
};
